export const GROUP_BY = {
  cellIndex: null,
  comparisonDataKey: 'category',
};

// Helper function to get the weight/volume or brand column based on platform flag
const getWeightVolumeOrBrandColumn = (hasPlatformExport) => {
  if (!hasPlatformExport) {
    return {
      type: 'PRODUCT_TEXT_BLOC',
      name: 'Marque',
      className: 'header_product-brand',
      dataType: 'manufacturer',
    };
  }
  return {
    type: 'PRODUCT_WEIGHT_VOLUME',
    name: 'Poids / Vol',
    className: 'header_product-weight',
    dataType: 'weight',
  };
};

// Function to get customer cart columns based on platform export flag
// Flag ON: Poids/Vol after Prix unitaire HT
// Flag OFF: Marque after Libellé produit
export const getCustomerCurrentCartColumnsItems = (hasPlatformExport) => {
  const columns = [
    {
      type: 'PRODUCT_IMAGE',
      dataType: 'image',
      name: 'Image',
      className: 'header_product-image',
    },
    {
      type: 'PRODUCT_WORDING',
      dataType: 'image',
      name: 'Libellé produit',
      className: 'header_product-wording',
    },
  ];

  // Flag OFF: Add Marque after Libellé
  if (!hasPlatformExport) {
    columns.push(getWeightVolumeOrBrandColumn(false));
  }

  columns.push(
    {
      type: 'PRODUCT_TEXT_BLOC',
      name: 'PCB',
      className: 'header_product-pcb',
      dataType: 'pcb',
    },
    {
      type: 'PRODUCT_PRICE',
      name: 'Prix unitaire HT',
      className: 'header_product-price',
      dataType: 'price',
    }
  );

  // Flag ON: Add Poids/Vol after Prix unitaire HT
  if (hasPlatformExport) {
    columns.push(getWeightVolumeOrBrandColumn(true));
  }

  columns.push(
    {
      type: 'PRODUCT_QUANTITY',
      name: 'Quantités',
      className: 'header_product-quantity',
      dataType: 'quantity',
    },
    {
      type: 'PRODUCT_PRICE_TOTAL',
      name: 'Total HT',
      className: 'header_product-total',
      dataType: 'final_price',
    },
    {
      type: 'PRODUCT_ACTION_DELETE',
      name: '',
      className: 'header_product-action',
    }
  );

  return columns;
};

// Keep backward compatibility
export const CUSTOMER_CURRENT_CART_COLUMNS_ITEMS = getCustomerCurrentCartColumnsItems(false);

export const COMMERCIAL_CURRENT_CART_COLUMNS_ITEMS = [
  {
    type: 'PRODUCT_IMAGE',
    dataType: 'image',
    name: 'Image',
    className: 'header_product-image',
  },
  {
    type: 'PRODUCT_WORDING',
    dataType: 'image',
    name: 'Libellé produit',
    className: 'header_product-wording',
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'Marque',
    className: 'header_product-brand',
    dataType: 'manufacturer',
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'PCB',
    className: 'header_product-pcb',
    dataType: 'pcb',
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'Prix unitaire HT',
    className: 'header_product-price',
    dataType: 'price',
  },
  {
    type: 'PRODUCT_QUANTITY_TEXT',
    name: 'Quantités',
    className: 'header_product-quantity',
    dataType: 'quantity_text',
  },
  {
    type: 'PRODUCT_PRICE_TOTAL',
    name: 'Total HT',
    className: 'header_product-total',
    dataType: 'final_price',
  },
];

export const CART_COLUMNS_ITEMS = [
  {
    type: 'PRODUCT_IMAGE',
    dataType: 'image',
    name: 'Image',
    className: 'header_product-image',
  },
  {
    type: 'PRODUCT_WORDING',
    dataType: 'image',
    name: 'Libellé produit',
    className: 'header_product-wording',
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'Marque',
    className: 'header_product-brand',
    dataType: 'manufacturer',
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'PCB',
    className: 'header_product-pcb',
    dataType: 'pcb',
  },
  {
    type: 'PRODUCT_PRICE',
    name: 'Prix unitaire HT',
    className: 'header_product-price',
    dataType: 'price',
  },
  {
    type: 'PRODUCT_QUANTITY_TEXT',
    name: 'Quantités',
    className: 'header_product-quantity',
    dataType: 'quantity_text',
  },
  {
    type: 'PRODUCT_PRICE_TOTAL',
    name: 'Total HT',
    className: 'header_product-total',
    dataType: 'final_price',
  },
  {
    type: 'PRODUCT_ACTION_DELETE',
    name: '',
    className: 'header_product-action',
  },
];

export const COLUMNS_LIST = [
  {
    type: 'PRODUCT_TEXT_BLOC',
    dataType: 'name',
    name: 'Nom du panier',
    className: 'header_product-wording',
    style: {
      isBold: true,
    },
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    dataType: 'is_preorder',
    name: 'Type',
    className: 'header_product-wording',
    style: {
      isBold: true,
    },
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    dataType: 'date_create',
    dataFormat: 'date',
    name: 'Date de création',
    className: 'header_product-brand',
    style: {
      isBold: true,
    },
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    dataType: 'totals_by_type',
    name: 'Références',
    className: 'header_product-pcb',
    style: {
      isBold: true,
    },
  },
  {
    type: 'PRODUCT_TEXT_BLOC',
    name: 'Total',
    className: 'header_product-price',
    dataType: 'total_price',
    style: {
      isBold: true,
    },
  },
];
